import React from 'react';

export default function StoreModal({ modal, setModal }) {
    if (!modal) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div 
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300" 
                onClick={() => setModal(false)}
            />
            
            {/* Modal Container */}
            <div className="relative w-full max-w-md bg-white rounded-[2.5rem] shadow-clinical overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-10 duration-500">
                <div className="p-10 text-center space-y-8">
                    {/* Header */}
                    <div className="flex justify-end absolute top-4 right-4">
                        <button 
                            onClick={() => setModal(false)}
                            className="p-3 bg-slate-50 rounded-2xl text-slate-400 hover:text-primary hover:bg-blue-50 transition-all group"
                        >
                            <span className="material-symbols-outlined group-hover:rotate-90 transition-transform">close</span>
                        </button>
                    </div>

                    <div className="w-20 h-20 bg-blue-50 rounded-3xl flex items-center justify-center text-primary mx-auto blob-shape">
                        <span className="material-symbols-outlined text-4xl">phone_iphone</span>
                    </div>

                    <div className="space-y-4">
                        <h2 className="text-3xl font-headline font-extrabold text-slate-900 tracking-tight">Get the Pairwota App</h2>
                        <p className="text-slate-500 text-sm leading-relaxed">Choose your platform below to download the app and start hydrating.</p>
                    </div>

                    <div className="flex justify-center gap-4 pt-4">
                        <a href="https://apps.apple.com/us/app/pair-wota/id1661711646" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105 hover:-translate-y-1">
                            <img alt="App Store" className="h-14 w-auto" src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"/>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.techtemple.pairwota&pli=1" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105 hover:-translate-y-1">
                            <img alt="Play Store" className="h-14 w-auto" src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
